export function Logo({
  className,
  symbolOnly = false,
  variant = "dark",
}: {
  className?: string;
  symbolOnly?: boolean;
  variant?: "light" | "dark";
}) {
  if (symbolOnly) {
    return (
      <img
        src={
          variant === "light"
            ? "https://localplatform.fly.storage.tigris.dev/assets/local-logo-symbol-on_light.svg"
            : "https://localplatform.fly.storage.tigris.dev/assets/local-logo-symbol-on_light.svg"
        }
        alt="Logo"
        className={className}
      />
    );
  }

  return (
    <img
      src={
        variant === "light"
          ? "https://localplatform.fly.storage.tigris.dev/assets/local-logo-wordmark-on_light.svg"
          : "https://localplatform.fly.storage.tigris.dev/assets/local-logo-wordmark-on_light.svg"
      }
      alt="Logo"
      className={className}
    />
  );
}
